import { Card, CardBody, Col, Table } from "reactstrap";
import GridTableBody from "./GridTableBody";
import GridTableHead from "./GridTableHead";
import { GridOptionsTitle } from "../../../../constants";
import { GridOptionsSubTitle } from "../../../../data/uiKits/Grid";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const GridOptions = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={GridOptionsTitle} span={GridOptionsSubTitle} />
        <CardBody>
          <div className="table-responsive custom-scrollbar">
            <Table bordered striped>
              <GridTableHead />
              <GridTableBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default GridOptions;
